module.exports = __webpack_public_path__ + "static/scale-model-of-muffler-man-in-escondido-california-bf24f77f3d705720e0960d9e2a7a6856.png";